// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TextHighlighter__container-bb2324 {
  --text-highlight-bg-color: var(--brand-secondary-40_15);
  --text-highlight-horizontal-padding: 1px;
  --text-highlight-border-radius: 0;
  --text-highlight-rounding-bg-x: 0;
  --text-highlight-rounding-bg-color-top: transparent;
  --text-highlight-rounding-bg-color-bottom: transparent;
  position: relative;
  user-select: none;
  pointer-events: none;
}

.TextHighlighter__wrapper-ef963e {
  position: absolute;
  left: 0;
  width: 100%;
}

.TextHighlighter__range-d863f3 {
  position: relative;
  display: block;
  border-radius: var(--text-highlight-border-radius);
  background-color: var(--text-highlight-bg-color);
  padding: 0 var(--text-highlight-horizontal-padding);
  margin-inline-start: calc(-1 * var(--text-highlight-horizontal-padding));
}

.TextHighlighter__range-d863f3::after,
.TextHighlighter__range-d863f3::before {
  content: "";
  position: absolute;
  width: var(--text-highlight-border-radius);
  height: 100%;
  background-image: radial-gradient(circle at var(--text-highlight-rounding-bg-x) 100%, transparent var(--text-highlight-border-radius), var(--text-highlight-rounding-bg-color-top) var(--text-highlight-border-radius)), radial-gradient(circle at var(--text-highlight-rounding-bg-x) 0, transparent var(--text-highlight-border-radius), var(--text-highlight-rounding-bg-color-bottom) var(--text-highlight-border-radius));
  background-size: var(--text-highlight-border-radius) var(--text-highlight-border-radius);
  background-repeat: no-repeat;
}

.TextHighlighter__range-d863f3::after {
  --text-highlight-rounding-bg-x: 0;
  background-position: top right, bottom right;
  right: 100%;
}

.TextHighlighter__range-d863f3::before {
  --text-highlight-rounding-bg-x: 100%;
  background-position: top left, bottom left;
  left: 100%;
}

.TextHighlighter__range-d863f3.TextHighlighter__left-top-touch-cf7ef5::after {
  --text-highlight-rounding-bg-color-top: var(--text-highlight-bg-color);
}

.TextHighlighter__range-d863f3.TextHighlighter__left-bottom-touch-a2d854::after {
  --text-highlight-rounding-bg-color-bottom: var(--text-highlight-bg-color);
}

.TextHighlighter__range-d863f3.TextHighlighter__right-top-touch-fc05bd::before {
  --text-highlight-rounding-bg-color-top: var(--text-highlight-bg-color);
}

.TextHighlighter__range-d863f3.TextHighlighter__right-bottom-touch-d0e863::before {
  --text-highlight-rounding-bg-color-bottom: var(--text-highlight-bg-color);
}

.TextHighlighter__left-top-straight-touch-b216b5,
.TextHighlighter__left-top-touch-cf7ef5 {
  border-top-left-radius: 0;
}

.TextHighlighter__left-bottom-straight-touch-d8ae9c,
.TextHighlighter__left-bottom-touch-a2d854 {
  border-bottom-left-radius: 0;
}

.TextHighlighter__right-top-straight-touch-c37a09,
.TextHighlighter__right-top-touch-fc05bd {
  border-top-right-radius: 0;
}

.TextHighlighter__right-bottom-straight-touch-c8a33e,
.TextHighlighter__right-bottom-touch-d0e863 {
  border-bottom-right-radius: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/TextHighlighter/TextHighlighter.styles.m.css"],"names":[],"mappings":"AAAA;EACE,uDAAA;EACA,wCAAA;EACA,iCAAA;EACA,iCAAA;EACA,mDAAA;EACA,sDAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;AACF;;AAEA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;EACA,kDAAA;EACA,gDAAA;EACA,mDAAA;EACA,wEAAA;AACF;;AAEA;;EAEE,WAAA;EACA,kBAAA;EACA,0CAAA;EACA,YAAA;EACA,8ZAAA;EAUA,wFAAA;EACA,4BAAA;AARF;;AAWA;EACE,iCAAA;EACA,4CAAA;EACA,WAAA;AARF;;AAWA;EACE,oCAAA;EACA,0CAAA;EACA,UAAA;AARF;;AAWA;EACE,sEAAA;AARF;;AAWA;EACE,yEAAA;AARF;;AAWA;EACE,sEAAA;AARF;;AAWA;EACE,yEAAA;AARF;;AAWA;;EAEE,yBAAA;AARF;;AAWA;;EAEE,4BAAA;AARF;;AAWA;;EAEE,0BAAA;AARF;;AAWA;;EAEE,6BAAA;AARF","sourcesContent":[".container {\n  --text-highlight-bg-color: var(--brand-secondary-40_15);\n  --text-highlight-horizontal-padding: 1px;\n  --text-highlight-border-radius: 0;\n  --text-highlight-rounding-bg-x: 0;\n  --text-highlight-rounding-bg-color-top: transparent;\n  --text-highlight-rounding-bg-color-bottom: transparent;\n  position: relative;\n  user-select: none;\n  pointer-events: none;\n}\n\n.wrapper {\n  position: absolute;\n  left: 0;\n  width: 100%;\n}\n\n.range {\n  position: relative;\n  display: block;\n  border-radius: var(--text-highlight-border-radius);\n  background-color: var(--text-highlight-bg-color);\n  padding: 0 var(--text-highlight-horizontal-padding);\n  margin-inline-start: calc(-1 * var(--text-highlight-horizontal-padding));\n}\n\n.range::after,\n.range::before {\n  content: '';\n  position: absolute;\n  width: var(--text-highlight-border-radius);\n  height: 100%;\n  background-image: radial-gradient(\n      circle at var(--text-highlight-rounding-bg-x) 100%,\n      transparent var(--text-highlight-border-radius),\n      var(--text-highlight-rounding-bg-color-top) var(--text-highlight-border-radius)\n    ),\n    radial-gradient(\n      circle at var(--text-highlight-rounding-bg-x) 0,\n      transparent var(--text-highlight-border-radius),\n      var(--text-highlight-rounding-bg-color-bottom) var(--text-highlight-border-radius)\n    );\n  background-size: var(--text-highlight-border-radius) var(--text-highlight-border-radius);\n  background-repeat: no-repeat;\n}\n\n.range::after {\n  --text-highlight-rounding-bg-x: 0;\n  background-position: top right, bottom right;\n  right: 100%;\n}\n\n.range::before {\n  --text-highlight-rounding-bg-x: 100%;\n  background-position: top left, bottom left;\n  left: 100%;\n}\n\n.range.left-top-touch::after {\n  --text-highlight-rounding-bg-color-top: var(--text-highlight-bg-color);\n}\n\n.range.left-bottom-touch::after {\n  --text-highlight-rounding-bg-color-bottom: var(--text-highlight-bg-color);\n}\n\n.range.right-top-touch::before {\n  --text-highlight-rounding-bg-color-top: var(--text-highlight-bg-color);\n}\n\n.range.right-bottom-touch::before {\n  --text-highlight-rounding-bg-color-bottom: var(--text-highlight-bg-color);\n}\n\n.left-top-straight-touch,\n.left-top-touch {\n  border-top-left-radius: 0;\n}\n\n.left-bottom-straight-touch,\n.left-bottom-touch {\n  border-bottom-left-radius: 0;\n}\n\n.right-top-straight-touch,\n.right-top-touch {\n  border-top-right-radius: 0;\n}\n\n.right-bottom-straight-touch,\n.right-bottom-touch {\n  border-bottom-right-radius: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TextHighlighter__container-bb2324`,
	"wrapper": `TextHighlighter__wrapper-ef963e`,
	"range": `TextHighlighter__range-d863f3`,
	"left-top-touch": `TextHighlighter__left-top-touch-cf7ef5`,
	"leftTopTouch": `TextHighlighter__left-top-touch-cf7ef5`,
	"left-bottom-touch": `TextHighlighter__left-bottom-touch-a2d854`,
	"leftBottomTouch": `TextHighlighter__left-bottom-touch-a2d854`,
	"right-top-touch": `TextHighlighter__right-top-touch-fc05bd`,
	"rightTopTouch": `TextHighlighter__right-top-touch-fc05bd`,
	"right-bottom-touch": `TextHighlighter__right-bottom-touch-d0e863`,
	"rightBottomTouch": `TextHighlighter__right-bottom-touch-d0e863`,
	"left-top-straight-touch": `TextHighlighter__left-top-straight-touch-b216b5`,
	"leftTopStraightTouch": `TextHighlighter__left-top-straight-touch-b216b5`,
	"left-bottom-straight-touch": `TextHighlighter__left-bottom-straight-touch-d8ae9c`,
	"leftBottomStraightTouch": `TextHighlighter__left-bottom-straight-touch-d8ae9c`,
	"right-top-straight-touch": `TextHighlighter__right-top-straight-touch-c37a09`,
	"rightTopStraightTouch": `TextHighlighter__right-top-straight-touch-c37a09`,
	"right-bottom-straight-touch": `TextHighlighter__right-bottom-straight-touch-c8a33e`,
	"rightBottomStraightTouch": `TextHighlighter__right-bottom-straight-touch-c8a33e`
};
module.exports = ___CSS_LOADER_EXPORT___;
